// extracted by mini-css-extract-plugin
export default {"quantitySelect":"QuantitySelect_quantitySelect__g+LP0"};